import {useEffect} from "react";
import CryptoJS from "crypto-js";

const AD_SRC_STORETALK = 'eyAiYWRQYXRoIiA6ICAiU1RPUkVUQUxLIn0=';

/**
 * storetalk intro page
 * https://www.bizting.co.kr/hosting/storetalk/intro
 * */
const HostingStoretalkIntro = () => {
    useEffect(() => {
        window.sessionStorage.setItem('adSrc', AD_SRC_STORETALK);

        const state = {
            hostType: 'STORETALK',
        };

        let encryptedState = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(state), process.env.REACT_APP_AES_ENCRYPT_KEY).toString());

        let url = `${process.env.REACT_APP_DEFAULT_INTRO_REDIRECT_URI}`;
        url += `?state=${encryptedState}`;
        url += `&ad_src=${encodeURIComponent(AD_SRC_STORETALK)}`;

        window.location.href = url;
    }, []);
};

export default HostingStoretalkIntro;
